import { render, staticRenderFns } from "./PaginaLoader.vue?vue&type=template&id=2586d4f6&"
import script from "./PaginaLoader.vue?vue&type=script&lang=js&"
export * from "./PaginaLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports